import { Dispatch, SetStateAction, useState } from 'react'
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
} from '@mui/material'
import ControlPointIcon from '@mui/icons-material/ControlPoint'
// import { AddButton } from '../forms'
import { ItemRow } from './row.component'
import { HelperWrapper } from 'src/components/helper-wrapper'
import { IRedirectURLRespDto } from 'src/types/redirect-url.type'
import { IFilter } from 'src/components/filter/types/filter.types'
import { ETranslationNs } from 'src/types'
import { RedirectURLModal } from '../modal/create-redirect-url.modal'

interface IProps {
  items: IRedirectURLRespDto[]
  sort: string
  setSort: Dispatch<SetStateAction<string>>
  setFilter: Dispatch<SetStateAction<IFilter>>
  filter: IFilter
}

export const RedirectURLTable = ({ items, sort, setSort, setFilter, filter }: IProps) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false)
  const handleSortChange = (sortName: string) => () => {
    setSort((prevSort) =>
      prevSort.split('-')[1] === 'asc' ? `${sortName}-desc` : `${sortName}-asc`,
    )
    setFilter({ ...filter, [sortName]: sort.split('-')[1] === 'asc' ? 'desc' : 'asc' })
  }

  const sortActive = sort.split('-')[0]
  const sortDirection = sort.split('-')[1] as 'desc' | 'asc'
  return (
    <>
      <Button
        sx={{ marginLeft: 'auto', marginBottom: 2 }}
        color={'primary'}
        size={'medium'}
        variant="contained"
        startIcon={<ControlPointIcon />}
        onClick={() => setModalOpen(true)}
      >
        <HelperWrapper t="button-add-new-text" />
      </Button>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell align="center">
                <TableSortLabel
                  onClick={handleSortChange('note')}
                  active={sortActive === 'note'}
                  direction={sortDirection}
                  sx={{
                    marginLeft: '20px',
                  }}
                >
                  <HelperWrapper t="redirect-url-note" />
                </TableSortLabel>
              </TableCell>
              <TableCell align="center">
                <TableSortLabel
                  onClick={handleSortChange('redirect_url')}
                  active={sortActive === 'redirect_url'}
                  direction={sortDirection}
                  sx={{
                    marginLeft: '20px',
                  }}
                >
                  <HelperWrapper t="redirect-url-text" />
                </TableSortLabel>
              </TableCell>
              <TableCell align="center">
                <TableSortLabel
                  onClick={handleSortChange('redirect_target')}
                  active={sortActive === 'redirect_target'}
                  direction={sortDirection}
                  sx={{
                    marginLeft: '20px',
                  }}
                >
                  <HelperWrapper t="redirect-target-text" />
                </TableSortLabel>
              </TableCell>
              <TableCell align="center">
                <TableSortLabel
                  onClick={handleSortChange('updated_at')}
                  active={sortActive === 'updated_at'}
                  direction={sortDirection}
                  sx={{
                    marginLeft: '20px',
                  }}
                >
                  <HelperWrapper t="table-modified-column" />
                </TableSortLabel>
              </TableCell>
              <TableCell align="center">
                <TableSortLabel
                  onClick={handleSortChange('active')}
                  active={sortActive === 'active'}
                  direction={sortDirection}
                  sx={{
                    marginLeft: '20px',
                  }}
                >
                  <HelperWrapper t="table-activated-column" ns={ETranslationNs.Users} />
                </TableSortLabel>
              </TableCell>
              <TableCell align="center"></TableCell>
              <TableCell align="center"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>{items?.map((row) => <ItemRow key={row.id} row={row} />)}</TableBody>
        </Table>
      </TableContainer>
      <RedirectURLModal modalOpen={modalOpen} setModalOpen={setModalOpen} />
    </>
  )
}
